import React, { useState, useRef, useEffect } from 'react';
import { 
  FaChevronDown,
  FaBars
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Header.css';

import logoEtef from '../../assets/images/logo-etef-.avif';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(null);
  const [activeDesktopDropdown, setActiveDesktopDropdown] = useState(null);
  const dropdownRefs = useRef({});

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      setMobileDropdown(null);
    }
  };

  const handleMobileDropdown = (dropdown) => {
    setMobileDropdown(mobileDropdown === dropdown ? null : dropdown);
  };

  // Fermer le dropdown si on clique ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (activeDesktopDropdown && 
          !dropdownRefs.current[activeDesktopDropdown]?.contains(event.target) &&
          !event.target.closest('.has-dropdown')) {
        setActiveDesktopDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeDesktopDropdown]);

  const servicesItems = [
    { text: "Étudiant étranger Hors France", link: "/etudiant-etranger-hors-france" },
    { text: "Étudiant étranger déjà en France", link: "/etudiant-etranger-en-france" },
    { text: "École - Université africaine", link: "/ecole-universite-africaine" },
    { text: "École - Université française", link: "/ecole-universite-francaise" }
  ];

  const aboutItems = [
    { text: "Qui sommes-nous", link: "/qui-sommes-nous" },
    { text: "L'équipe ETEF", link: "/equipe-etef" },
    { text: "Universités partenaires", link: "/universites-partenaires" },
    { text: "Nos représentants", link: "/representants" }
  ];

  const navItems = [
    { text: "Accueil", link: "/" },
    { 
      text: "Nos services", 
      link: "/services",
      dropdown: servicesItems,
      key: "services"
    },
    { text: "Évènements", link: "/evenements" },
    { text: "Associations", link: "/association" },
    { 
      text: "À propos", 
      link: "/a-propos",
      dropdown: aboutItems,
      key: "apropos"
    },
    { text: "Contact", link: "/contact" },
    { text: "Blog", link: "/blog" }
  ];

  const toggleDesktopDropdown = (itemKey, e) => {
    // Empêche la navigation seulement si on clique sur la flèche
    if (e.target.closest('.dropdown-arrow') || e.target.closest('.nav-link.has-dropdown')) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    setActiveDesktopDropdown(activeDesktopDropdown === itemKey ? null : itemKey);
  };

  return (
    <header className="header">
      {/* Overlay pour fermer le menu mobile */}
      <div 
        className={`mobile-close-overlay ${isMenuOpen ? 'show' : ''}`} 
        onClick={toggleMenu}
      />

      <div className="header-container">
        <div className="header-main">
          <div className="header-logo">
            <Link to="/" className="logo-link">
              <img 
                src={logoEtef} 
                alt="ETEF - Études en France" 
                className="header-logo-image"
              />
            </Link>
          </div>

          <nav className="header-nav">
            <ul className="nav-list">
              {navItems.map((item, index) => (
                <li 
                  key={index} 
                  className={`nav-item ${item.dropdown ? 'has-dropdown' : ''}`}
                  onMouseEnter={() => item.dropdown && setActiveDesktopDropdown(item.key)}
                  onMouseLeave={() => item.dropdown && setActiveDesktopDropdown(null)}
                >
                  <Link 
                    to={item.link} 
                    className={`nav-link ${item.dropdown ? 'has-dropdown' : ''}`}
                    onClick={(e) => toggleDesktopDropdown(item.key, e)}
                  >
                    <span className="nav-text">{item.text}</span>
                    {item.dropdown && <FaChevronDown className="dropdown-arrow" />}
                  </Link>
                  
                  {item.dropdown && (
                    <div 
                      ref={el => dropdownRefs.current[item.key] = el}
                      className={`dropdown-menu ${activeDesktopDropdown === item.key ? 'show' : ''}`}
                      onMouseEnter={() => setActiveDesktopDropdown(item.key)}
                      onMouseLeave={() => setActiveDesktopDropdown(null)}
                    >
                      {item.dropdown.map((dropdownItem, idx) => (
                        <Link 
                          key={idx} 
                          to={dropdownItem.link} 
                          className="dropdown-item"
                          onClick={() => setActiveDesktopDropdown(null)}
                        >
                          <span className="dropdown-text">{dropdownItem.text}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div className="header-actions">
            <Link to="/paiements" className="header-subscribe-btn">
              <span className="header-btn-text">Souscrire</span>
            </Link>
            <a 
              href="https://plateforme.etef-design.fr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="header-platform-btn"
            >
              <span className="header-btn-text">Plateforme</span>
            </a>
          </div>

          <button 
            className="mobile-toggle" 
            onClick={toggleMenu}
            aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
          >
            <FaBars />
          </button>
        </div>

        <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
          <div className="mobile-menu-header">
            <div className="mobile-logo">
              <img 
                src={logoEtef} 
                alt="ETEF" 
                height="36"
              />
            </div>
            <button 
              className="mobile-close-btn"
              onClick={toggleMenu}
              aria-label="Fermer le menu"
            >
              
            </button>
          </div>

          <ul className="mobile-nav">
            {navItems.map((item, index) => (
              <li key={index} className="mobile-nav-item">
                <div className="mobile-item-header">
                  <Link 
                    to={item.link} 
                    className="mobile-nav-link" 
                    onClick={(e) => {
                      if (item.dropdown) {
                        e.preventDefault();
                        handleMobileDropdown(item.key);
                      } else {
                        setIsMenuOpen(false);
                      }
                    }}
                  >
                    <span className="mobile-nav-text">{item.text}</span>
                  </Link>
                  {item.dropdown && (
                    <button 
                      className="mobile-dropdown-toggle"
                      onClick={() => handleMobileDropdown(item.key)}
                      type="button"
                      aria-expanded={mobileDropdown === item.key}
                    >
                      <FaChevronDown className={`toggle-arrow ${mobileDropdown === item.key ? 'rotated' : ''}`} />
                    </button>
                  )}
                </div>
                
                {item.dropdown && mobileDropdown === item.key && (
                  <div className="mobile-dropdown">
                    {item.dropdown.map((dropdownItem, idx) => (
                      <Link 
                        key={idx} 
                        to={dropdownItem.link} 
                        className="mobile-dropdown-item"
                        onClick={() => {
                          setIsMenuOpen(false);
                          setMobileDropdown(null);
                        }}
                      >
                        <span className="mobile-dropdown-text">{dropdownItem.text}</span>
                      </Link>
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>

          <div className="mobile-actions">
            <Link 
              to="/paiements" 
              className="mobile-subscribe-btn"
              onClick={() => setIsMenuOpen(false)}
            >
              <span className="header-btn-text">Souscrire</span>
            </Link>
            <a 
              href="https://plateforme.etef-design.fr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mobile-platform-btn"
              onClick={() => setIsMenuOpen(false)}
            >
              <span className="header-btn-text">Plateforme</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;